const tasksRouterPaths = {
  root: '/tasks',
  taskDetails: '/tasks/:taskId',
};

export default tasksRouterPaths;
